import React from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import appStyles from '../App/appStyles.scss'
import { RidePickerContainer, getTitle } from '../RidePicker'
import { rrMessages } from '../intlMessages'
import styles from './NewPage.scss'
import { Navbar, NavbarGroup, NavbarTitle } from 'common/Navbar'
import { Button } from 'common/Button'
import { Gleam } from 'common/Gleam'
import { getConsole } from 'lib/getConsole'
import * as reportActions from 'lib/api/rideReports'
import { Msg, featureNames, commonCTAs } from 'lib/localization'
import cx from 'classnames'
import { FormattedMessage as T, injectIntl } from 'react-intl'
const console = getConsole('rr', 'NewPage')

export class NewPage extends React.Component {
  createReport = (selectedRides) => {
    const { newReport, history, intl } = this.props
    // also generates a subtitle, but we ignore it because users can't
    // figure out how to change the defaults
    const { title } = getTitle(selectedRides, intl)
    newReport({
      title,
      rides: selectedRides.toIndexedSeq().map(r => r.id).toJS()
    }).then(response => {
      history.push(`/ride_reports/${response.value.report.slug}/edit`)
    }).catch(err => {
      console.error(err, err.stack)
    })
  }

  render () {
    const { draftCount, currentUser } = this.props

    if (!currentUser.id) {
      window.location.href = `/login?redirect=${encodeURIComponent(window.location.href)}`
      return null
    }

    return (
      <div className={cx(appStyles.base, styles.wrapper)}>
        <Navbar>
          <NavbarGroup>
            <li><NavbarTitle to='/ride_reports'><Msg m={featureNames.rideReports} /></NavbarTitle></li>
            <li><Msg m={rrMessages.newReport} /></li>
          </NavbarGroup>
          <NavbarGroup>
            <li><Link to='/ride_reports/drafts'><T id='NewPage.yourDrafts' defaultMessage='your drafts' /> {draftCount > 0 && <Gleam>{draftCount}</Gleam>}</Link></li>
            <li><Link to='/ride_reports/'><Button type='default'>&laquo; <Msg m={commonCTAs.back} /></Button></Link></li>
          </NavbarGroup>
        </Navbar>
        <div className={styles.NewPage}>
          <h1 className={appStyles.pageTitle}><T id='NewPage.newRR' defaultMessage='New Ride Report' /></h1>
          <p><T id='NewPage.whichRides' defaultMessage='Which rides do you want to write a ride report for?' /></p>
          <RidePickerContainer onConfirmSelection={this.createReport} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUser,
    draftCount: state.editPage.draftList.size
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    newReport: (report) => dispatch(reportActions.newReport(report))
  }
}

export const NewPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(injectIntl(NewPage)))
